import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import useAuth from '../../../hooks/useAuth';

const Register = () => {
    const{handleUserRegister}= useAuth();

    const [email, setEmail]=useState('');
    const [password, setPassword]= useState('');
    

    const handleEmail=(e)=>{
        setEmail(e.target.value);
        
    }
    const handlePassword=(e)=>{
        setPassword(e.target.value);
      
    }
    const handleRegister=(e)=>{
        e.preventDefault();
        handleUserRegister(email, password)
        
    }
    return (
        <div className="mt-5 mb-5 pt-5 pb-5 pt-5">
           <h2>please Register</h2>
           <form>
               <input onChange={handleEmail} type="email" placeholder="Enter your Email" id="" required/><br />
               <input onChange={handlePassword} type="password" placeholder="your password" id="" required/><br />
               <input type="text" placeholder=" name" id="" required /><br />
               <input className="btn btn-danger" onClick={handleRegister} type="submit" value="Submit" />
           </form>
           <Link to="/login">Already Registered?</Link>
        </div>
    );
};

export default Register;